import React from 'react';
import { useSelector } from 'react-redux';
import { CategoryType } from 'src/graphql';
import { useIsFeatureEnabled } from 'src/hooks';
import * as Types from '../../../types';
import { CategoryBodyDynamicQuestionsLayout } from './CategoryBodyDynamicQuestionsLayout';

interface Props {
  category: CategoryType;
  currentCategory: CategoryType | null;
  setCurrentCategory: React.Dispatch<React.SetStateAction<CategoryType | null>>;
  isCurrentCategory: boolean;
  onDefaultFlowIntakeValidityChange?: (valid: boolean) => void;
}

export const CategoryBody = ({
  category,
  currentCategory,
  setCurrentCategory,
  isCurrentCategory,
  onDefaultFlowIntakeValidityChange,
}: Props) => {
  const vaultTalkEnabled = useIsFeatureEnabled(Types.FeatureFlag.VAULT_TALK);
  const slackEnabled = useIsFeatureEnabled(Types.FeatureFlag.SLACK_REPORTING);
  const oprEnabled = useIsFeatureEnabled(Types.FeatureFlag.PUBLIC_REPORTING);
  const goTogetherEnabled = useIsFeatureEnabled(Types.FeatureFlag.GO_TOGETHER);
  const dynamicQuestionsV1 = useIsFeatureEnabled(
    Types.FeatureFlag.DYNAMIC_QUESTIONS_V1,
  );
  const isLegacyMode = useSelector(
    (state: Types.State) => state.organisation?.isLegacyMode,
  );

  const effectiveLegacy = Boolean(isLegacyMode) || !dynamicQuestionsV1;

  return (
    <CategoryBodyDynamicQuestionsLayout
      category={category}
      currentCategory={currentCategory}
      setCurrentCategory={setCurrentCategory}
      isCurrentCategory={isCurrentCategory}
      vaultTalkEnabled={effectiveLegacy || vaultTalkEnabled}
      slackEnabled={effectiveLegacy || slackEnabled}
      oprEnabled={effectiveLegacy || oprEnabled}
      goTogetherEnabled={effectiveLegacy || goTogetherEnabled}
      dynamicQuestionsV1={dynamicQuestionsV1}
      isLegacyMode={effectiveLegacy}
      onDefaultFlowIntakeValidityChange={onDefaultFlowIntakeValidityChange}
    />
  );
};
